module.exports = __webpack_public_path__ + "static/media/fig_8a.d04ace76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_8a.jpg
// module id = 681
// module chunks = 0